import { IAuftrag } from '../../../models/ApiTypes';
import * as React from 'react';

/**
 * Komponente die die im Auftrag erbrachten und für den Dienstleistungsnachweis relevanten Dienstleistungen inkl. Anzahl auflistet
 * Daran kann sich der Anwender beim Ausfüllen des Dienstleistungsnachweises orientieren
 */
export default class DienstleistungsUebersicht extends React.Component<{auftrag?: IAuftrag}, {}> {

  render() {
    const auftrag = this.props.auftrag;

    if (auftrag) {
      var dienstleistungsListe: {[key: string]: number} = {};
      const ausschlussBegriffe = ['dienstleistungsnachweis', 'angebot'];
      auftrag.vorgaenge.forEach(element => {
        // Nicht alle Dienstleistungen sind für die Abrechnung relevant und werden über eine Ausschlußliste übersprungen
        var skip = false;
        ausschlussBegriffe.forEach(e => (skip = skip || element.kuerzel_dienstleistung.toLocaleLowerCase().indexOf(e) !== -1 ));
        if (!skip) {
          dienstleistungsListe[element.kuerzel_dienstleistung] = (dienstleistungsListe[element.kuerzel_dienstleistung] + 1) || 1;
          // Einige Dienstleistungen wie die SES Vermessung bestehen aus mehreren Unterschritten, diese sollen nicht mehrfach gezählt werden
          if ((auftrag.kategorie === 'ses') && (element.kuerzel_dienstleistung.toLocaleLowerCase().indexOf('vermessung') !== -1)) {
            dienstleistungsListe[element.kuerzel_dienstleistung] = 1;
          }
        }
      });
      if (Object.keys(dienstleistungsListe).length > 0) {
        return (
          <div>
            <h3>
              Übersicht
            </h3>
            <div>Die folgenden Dienstleistungen wurden im Auftrag gewählt, nutzen Sie diese als Grundlage für den Dienstleistungsnachweis:</div>
            <ul>
              {Object.keys(dienstleistungsListe).map(key => { return <li>{dienstleistungsListe[key]} x {key}</li>; })}
            </ul>
          </div>);
      }
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/abrechnung/DienstleistungsUebersicht.tsx